import { useState } from 'react'
import { Link } from 'react-router-dom'
import Icon from '../components/Icon.jsx'

const FAQS = [
  {
    q: 'Are prices inclusive of GST?',
    a: 'No — all prices on the site are shown ex GST. GST (10%) is added at checkout and shown clearly before you pay.',
  },
  {
    q: 'Which shower screen configuration do I need?',
    a: 'Corner shower (two walls): 3 Panel A or 3 Panel B — choose A or B depending on which side the door hinges. Alcove/inline shower (one wall): 2 Panel A, 2 Panel B or 3 Panel In-Line. Larger corner: 4 Panel Corner. Not sure? Send us a photo and measurements and we\'ll advise for free.',
  },
  {
    q: 'What glass thickness do you use?',
    a: 'Frameless screens use 10mm toughened safety glass as standard. Semi-frameless ranges (Semi Pro, Sliding Series) use 6mm ultra clear glass. All glass complies with AS/NZS 2208.',
  },
  {
    q: 'What hardware finishes are available?',
    a: 'Six finishes: Chrome, Matte Black, Brushed Nickel, Brushed Gold, Brushed Brass and Brushed Gunmetal. Availability varies by range — check each product page.',
  },
  {
    q: 'Can I order a custom size?',
    a: 'Yes — most frameless screens and glass panels can be made to measure. Custom glass requires full payment upfront, we confirm measurements before cutting, and custom items can\'t be returned unless faulty. Contact us for lead times.',
  },
  {
    q: 'How do I pay?',
    a: 'Two ways: pay securely by card (Visa, Mastercard, Amex) through Stripe and your order is confirmed instantly, or pay by direct bank transfer using the unique reference shown at checkout — bank transfers are verified usually the same business day. We never see or store your card details.',
  },
  {
    q: 'How does delivery work?',
    a: 'We deliver within 50 km of our Ravenhall warehouse (Victoria only) for a flat rate shown at checkout — typically 1–3 business days after dispatch. Stocked hardware dispatches in 1–2 business days; stocked glass panels in 2–3. Warehouse pickup in Ravenhall is always free.',
  },
  {
    q: 'What warranty and returns do you offer?',
    a: 'Hardware carries a 2-year warranty against manufacturing defects. Glass is inspected before dispatch (size tolerance up to 3mm) and isn\'t warrantied once installed. Eligible stocked items can be returned within 30 days; custom-made glass can\'t be returned unless faulty.',
  },
]

export default function Faq() {
  const [open, setOpen] = useState(0)
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>FAQ</span></nav>
      <header className="page-head">
        <h1>Frequently asked questions</h1>
        <p>Everything you need to know before you order. Still stuck? <Link to="/contact">Contact us</Link>.</p>
      </header>
      <div className="faq-list">
        {FAQS.map((f, i) => (
          <details key={f.q} open={open === i} onClick={(e) => { e.preventDefault(); setOpen(open === i ? -1 : i) }}>
            <summary>
              {f.q}
              <Icon name="chevronDown" size={18} className={open === i ? 'flip' : ''} />
            </summary>
            <p>{f.a}</p>
          </details>
        ))}
      </div>
    </main>
  )
}
